const moduleName = "detailPenerimaanModule";

const state = {
  outletData: {},
  filterTransaksi: {},
  filterCount: null,
  detailPenerimaan: {},
  defaultFilter: {}
};

export { state as default, moduleName };
